/**
 * Sign-up page
 * initial it by passing sign-up form ID
 **/
import FormMessageHandler from './formMessageHandler';

let Spinner = require('spin');
let cacoo = require('../components/cacoo').cacoo;

/**
 * Options properties:
 *    - noEmailExistValidation: Check the email exists in the database
 * Sign-up success and failure callback
 *    - signup.submitForm(context, success, fail)
 */
export default class SigninHandler {
  constructor(formId, options = {}) {
    this.body = $('body');
    this.form = $('form#' + formId, this.body);
    this.email = $("input#name", this.form);
    this.password = $("input#password", this.form);
    this.autoLogin = $('input#autoLogin', this.form);
    this.submitButton = $('button[type="submit"]', this.form);
    this.formMessageHandler = new FormMessageHandler(this.form);

    if (cacoo.util.getUrlParameter("existingAccount") === "true") {
      $('input[name="next"]', this.form).val(`${Cacoo.settings.baseUrl}/team/try`);
    } else {
      $('input[name="next"]', this.form).val(cacoo.util.getUrlParameter("next"));
    }
    $('input[name="consent"]', this.form).val(cacoo.util.getUrlParameter("consent"));

    this.buttonSpinner = new Spinner({color: '#fff', lines: 12});

    this.attachEvent();
  }

  attachEvent() {
    this.email.on('focusout', () => this.mailValidate());
    this.password.on('focusout', () => this.passwordValidate());

    this.submitButton.on('click', (e) => {
      e.preventDefault();
      this.submitForm();
      return false;
    });
  }

  mailValidate() {
    if (!cacoo.util.validateEmail(this.email.val())) {
      this.formMessageHandler.showError('name', Cacoo.SiteResources['modal_signup_email_error']);
      return false;
    } else {
      this.formMessageHandler.removeError('name');
    }
  }

  passwordValidate() {
    if (this.password.val().length > 0) {
      this.formMessageHandler.removeError('password');
    } else {
      this.formMessageHandler.showError('password', Cacoo.SiteResources['modal_signup_password_empty_error']);
    }
  }

  finalValidate() {
    this.mailValidate();
    this.passwordValidate();

    return (!this.email.hasClass("is_error") && !this.password.hasClass("is_error"));
  }

  getFormData() {
    let formData = (this.form.serializeArray());
    let formJSON = {};
    $.each(formData, function (i, d) {
      formJSON[d.name] = d.value;
    });

    return formJSON;
  }

  submitForm() {
    if (!this.finalValidate()) {
      return false;
    }
    const data = this.getFormData();
    this.submitSigninForm(data)
  }

  submitSigninForm(data) {
    if (this.submitButton.hasClass('disable')) {
      return false;
    }

    cacoo.ajax({
      url: this.form.attr('action'),
      method: "POST",
      data: data,
      beforeSend: () => {
        this.startButtonSpinner();
      },
      success: (resp) => {
        this.submitForm_load(resp);
        dataLayer.push({'event': 'Login Success'});
      },
      error: (XMLHttpRequest, textStatus, errorThrown) => {
        this.stopButtonSpinner();
        if (XMLHttpRequest.status === 401) {
          this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signin_invalid']);
        } else {
          this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signin_default_error']);
        }

        return false;
      },
    });
  }

  submitForm_load(resp) {
    if (!resp['signinURL']) {
      this.stopButtonSpinner();
      this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signin_default_error']);
      return false;
    }
    window.location.href = resp['signinURL'];
  }

  startButtonSpinner() {
    this.submitButton.addClass('disable');
    this.buttonSpinner.spin(this.submitButton.get(0));
  }

  stopButtonSpinner() {
    this.submitButton.removeClass('disable');
    this.buttonSpinner.stop();
  }

}
